import _extends from 'babel-runtime/helpers/extends';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { PureComponent } from 'react';

/* HOC wrapper to handle a temporary disabled feature */
export default function wrapper() {
  return function (WrappedComponent) {
    var Disable = function (_PureComponent) {
      _inherits(Disable, _PureComponent);

      function Disable(props) {
        _classCallCheck(this, Disable);

        var _this = _possibleConstructorReturn(this, (Disable.__proto__ || Object.getPrototypeOf(Disable)).call(this, props));

        _this.disable = function () {
          _this.setState({
            disabled: true
          });
        };

        _this.enable = function () {
          _this.setState({
            disabled: false
          });
        };

        _this.disableTemporary = function (secs) {
          _this.setState({
            disabled: true
          });
          _this.timeout = setTimeout(function () {
            _this.setState({
              disabled: false
            });
          }, secs * 1000);
        };

        _this.state = {
          disabled: false
        };
        return _this;
      }

      _createClass(Disable, [{
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          clearTimeout(this.timeout);
        }
      }, {
        key: 'render',
        value: function render() {
          var _this2 = this;

          return React.createElement(WrappedComponent, _extends({
            ref: function ref(c) {
              _this2.wrappedComponent = c;
            }
          }, this.state, this.props, {
            disableTemporary: this.disableTemporary,
            disable: this.disable,
            enable: this.enable
          }));
        }
      }]);

      return Disable;
    }(PureComponent);

    return Disable;
  };
}
//# sourceMappingURL=Disable.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/HOC/Disable.js
// module id = 483
// module chunks = 0